let translationsAADAT = {
	forSell: 'For Sale',
	forRent: 'For Rent',
	gasCirco: 'Gas - Circo',
	gasConvector: 'Gas - Convector',
	gasHera: 'Gas - Hera',
	remoteHeating: 'Remote heating',
	remoteHeatingWithOwnMeasurer: 'Remote heating with Own Measurer',
	electric: 'Electric',
	houseCentralized: 'House Centralized',
	houseCentralizedWithUniqueMeter: 'House centralized with unique meter',
	geotermic: 'Geotermic',
	gasAndAlternative: 'Gas and alternative',
	furnace: 'Furnace',
	stove: 'Stove',
	fanCoil: 'Fan coil',
	otherHeating: 'Other',
	nothing: 'None',
	airHeating: 'Air heating',
	radiatorHeating: 'Radiator heating',
	floorHeating: 'Floor heating',
	wallHeating: 'Wall heating',
	ceilingHeating: 'Ceiling heating',
	HEATING: 'Heating',
	condition: 'Condition',
	room: 'Room',
	halfRoom: 'Halfroom',
	kitchen: 'Kitchen',
	livingroom: 'Living room',
	bathroom: 'Bathroom',
	bathroomWithToilet: 'Baathroom with toilet',
	toilet: 'Toilet',
	balcony: 'Balcony',
	caller: 'Caller',
	service: 'Service',
	none: 'None',
	key: 'Key',
	closed: 'Close',
	circularCorridor: 'Circular corridor',
	other: 'Other',
	roomGarage: 'Room garrage',
	closedPlace: 'Closed place',
	openedPlace: 'Opened place',
	publicPayment: 'Public payment',
	publicFree: 'Public free',
	noGarage: 'No',
	true: 'Yes',
	false: 'No',
	uninhabitable: 'Uninhabitable',
	toRenew: 'To renew',
	average: 'Average',
	good: 'Good',
	excellent: 'Excellent',
	newlyBuilt: 'Newly built',
	brick: 'Brick',
	panel: 'Panel',
	shutter: 'Shutter',
	wood: 'Wood',
	lightStructure: 'Light structure',
	adobe: 'Adobe',
	silicate: 'Silicate',
	proconcept: 'Proconcept',
	rockAndBrick: 'Rock and brick',
	woodHouse: 'Wood house',
	mixedMasonry: 'Mixed masonry',
	passiveHouse: 'Passive house',
	otherBuildingMaterial: 'Other',
	diningroom: "Ebédlő",
	bad: 'Bad',
	medium: 'Medium',
	sunny: 'Sunny',
	east: 'East',
	southeast: 'South east',
	south: 'South',
	southwest: 'South west',
	west: 'West',
	northwest: 'North west',
	north: 'North',
	northeast: 'North east',
	street: 'Street',
	yard: 'Yard',
	garden: 'Garden',
	panorama: 'Panorama',
	withoutComfort: 'Without comfort',
	halfComfort: 'Half comfort',
	comfort: 'Comfort',
	fullComfort: 'Full comfort',
	doubleComfort: 'Double comfort',
	luxurious: 'Luxurious',
	pool: 'Pool',
	withGardenAccess: 'With garden access',
	topFloor: 'Top floor',
	navigationWithKeyboard: 'Navigation with keyboard',
	prevPic: 'Previous picture',
	nextPic: 'Next picture',
	thumbnails: 'Thumbnails',
	zoom: 'Zoom',
	close: 'Close',
	district: 'district',
	price: 'Price',
	area: 'Area',
	numOfRooms: 'Number of rooms',
	sqm: 'sqm',
	half: 'half',
	floor: 'Floor',
	indoorHeight: 'Indoor height',
	frenchBalcony: 'French Balcony',
	terrace: 'Terrace',
	roofTerrace: 'Roof Terrace',
	loggia: 'Loggia',
	numberOfBathrooms: 'Number of bathrooms',
	saveSearch: 'Save search',
	saveSearchText: 'Please type the name of the search',
	saveSearchLabel: 'Name of the search',
	bathroomAndToilet: 'Bathroom and toilet',
	lightCondition: 'Light condition',
	monthlyPrice: 'Rezsi közösköltséggel angolul',
	separate: 'külön angol',
	common: 'egyben angol',
	separateAndCommon: 'külön és egyben angol',

	/** advanced search */

	baseDatas: 'Base datas',
	size: 'Size',
	convenience: 'Convenience',
	extras: 'Extras',
	gas: 'Gas',
	buildingMaterial: 'Building material',
	countOfRooms: 'Count of rooms',
	elevator: 'Elevator',
	hasElevator: 'Yes',
	floorsOfTheBuilding: 'Floors of the building',
	parking: 'Parking',
	balconyLabel: 'Balcony / terrace',
	view: 'View',
	stairwell: 'Stairwell',
	orientation: 'Orientation',
	keyword: 'Keyword',
	advancedSearch: 'Advanced search',
	propertyType: 'Property type',
	garageTitle: 'Yes I like parking',

	/** összehasonlítás címkék */

	location: 'Location',
	roomCount: 'Room count',

	/** */

	buildingYear: 'Building year',
	conditionOut: 'Condition out',
	conditionIn: 'Condition in',
	storageRoom: 'Storage room',

	/** átlagárak diagram */

	avgPricesTitle: 'avg prices title',
	avgPricesProperty: 'avg prices property',
	avgPricesAround: 'avg prices around',
	avgPriceDiagramTitle: 'avg prices diagram title',

	/** Térkép */

	subway: 'Subway',
	bus: 'Bus',
	tram: 'Tram',
	minute: 'minute',

	/** Megosztás */

	shareInEmail: 'Share in E-mail',
	copyLink: 'Copy link',

	/** Hasonló ingatlanok */

	similarTitle: 'Hasonló ingatlanok angol',
	projectTitle: 'Ingatlanok ebből a projektből angol',
	moreProjectLink: 'További ingatlanok ebből a projektből angol',

	/** Tanácsadó */

	agentTitle: 'Agent:',
	refNumberText: 'Ref number blabla:',
	sendMessageButtonText: 'Send message',

	/** Illeték */

	dutyTitle: 'Duty:',
	dutyInfo: '*English duty blabla.',

	/** Kalkulátor */

	loanTitle: 'eng title',
	loanPropertyPrice: 'loanPropertyPrice',
	loanErrorOnCalculation: 'loanErrorOnCalculation',
	loanArp: 'ARP',
	loanAmount: 'loanAmount',
	loanTime: 'loanTime',
	loanYear: 'Year',
	loanMonthlyPrice: 'loanMonthlyPrice',
	loanInterestedIn: 'loanInterestedIn',
	loanMoreInfo: 'loanMoreInfol',

	webWalk: '3D Webwalk'
};

export default translationsAADAT;
